<template>
  <div>
    <b-alert
      :show="alerts.radius"
      variant="danger">
      You are not within radius!
    </b-alert>
    <b-alert
      :show="alerts.geoLocBlocked"
      class="text-center"
      variant="danger">
      Please allow VMTS to use your location then refresh this page.
    </b-alert>

    <div v-show="!alerts.geoLocBlocked">
      <div
        class="text-muted mb-3 text-monospace"
        style="font-size: 12px">
        {{ locationAddress }}
      </div>
      <select
        v-model="model.selectedZone"
        class="form-control"
        @change="zoneChanged">
        <option
          :value="null"
          disabled>-- Select zone --</option>
        <option
          v-for="zone in zones"
          :key="zone.CODE"
          :value="zone.CODE"
          v-text="zone.NAME"/>
      </select>
      <select
        v-model="model.selectedStation"
        :disabled="!model.selectedZone"
        class="form-control mt-2"
        @change="stationChanged">
        <option
          :value="null"
          disabled>
          -- Select station --
        </option>
        <option
          v-for="station in filteredStations"
          :key="station.CODE"
          :value="station.CODE"
          v-text="station.NAME"/>
      </select>
      <b-btn
        :disabled="disableButton"
        class="mt-3"
        block
        variant="primary"
        @click="next">
        Next <i class="icon-arrow-right"/>
      </b-btn>
    </div>
  </div>
</template>
<script>
import orderBy from 'lodash/orderBy'
import { mapState } from 'vuex'
import { Spinner } from '@/components/'
import { auth } from '@/services/'
import { sendEvent } from '@/services/socket'

export default {
  name: 'CleaningForm1',
  components: {
    Spinner
  },
  data () {
    return {
      model: {
        selectedZone: null,
        selectedStation: null
      },
      location: {},
      locationAddress: '',
      distance: undefined,
      alerts: {
        radius: false,
        geoLocBlocked: false
      },
    }
  },
  computed: {
    ...mapState('cleaning', [
      'zones',
      'stations'
    ]),
    filteredStations () {
      return orderBy(this.stations.filter(station => station.ZONE_CODE === this.model.selectedZone), 'NAME')
    },
    disableButton () {
      if (auth.getUser().USER_NAME === 'lgfuad13@ymail.com') {
        return false
      }
      return this.locationRadius === null || this.alerts.radius
    }
  },
  created () {
    this.getLocation()
  },
  methods: {
    getLocation() {
      if(navigator.geolocation) {
        let watchID = navigator.geolocation.watchPosition(this.showPosition, err => {
          if (err.code === 1) {
            this.alerts.geoLocBlocked = true
          }
        })
        setTimeout( () => { navigator.geolocation.clearWatch( watchID ) }, 5000 )
      } else {
        alert("Geo Location not supported by browser");
      }
    },
    showPosition(position) {
      this.location = {
        lng: position.coords.longitude,
        lat: position.coords.latitude
      }
      /* eslint-disable no-undef */
      let geocoder = new google.maps.Geocoder
      geocoder.geocode({'location': this.location}, (results, status) => {
        if (status === 'OK') {
          if (results[0]) {
            this.locationAddress = results[0].formatted_address
          }
        }
      })
    },
    zoneChanged () {
      this.model.selectedStation = null
    },
    stationChanged () {
      let station = this.stations.find(obj => obj.CODE === this.model.selectedStation)
      let { STATION_LAT, STATION_LNG } = station
      const originalDistance = google.maps.geometry.spherical.computeDistanceBetween(
        new google.maps.LatLng(STATION_LAT, STATION_LNG),
        new google.maps.LatLng(this.location.lat, this.location.lng)
      )
      this.distance = Math.floor(originalDistance)
      if (this.distance > 200) {
        this.alerts.radius = true
      } else {
        this.alerts.radius = false
      }
      this.$store.commit('cleaning/setSelectedStation', station)
      this.$store.commit('cleaning/setAvailableCars', this.model.selectedStation)
    },
    next () {
      this.$store.commit('cleaning/setSteps', 2)
      let station = this.stations.find(obj => obj.CODE === this.model.selectedStation)
      sendEvent('CLEANER_EVENT', {
        page: '/cleaning',
        eventName: 'SUBMIT_STATION_SELECTION',
        eventDetail: {
          stationName: station.NAME,
          cleanerLocation: this.locationAddress,
          distanceWithStation: `${this.distance} meters`
        }
      })
    }
  },
}
</script>
